import React, { useEffect, useState } from 'react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { Tooltip, IconButton } from '@wix/design-system';
import { ChangeOrderSmall } from '@wix/wix-ui-icons-common';
import { MultiLevelSortingState, ToolbarCollectionState } from '../../state';
import { MultiLevelSortingPanelEntry } from '../MultiLevelSortingPanel';
import { CounterBadgeButton } from '../CounterBadgeButton';

export interface MultiLevelSortingCTAButtonProps<T, F extends FiltersMap> {
  state: ToolbarCollectionState<T, F>;
}

export function _MultiLevelSortingCTAButton<T, F extends FiltersMap>(
  props: MultiLevelSortingCTAButtonProps<T, F>,
) {
  const { state } = props;
  const {
    panels,
    container: { translate: t },
  } = state;

  const [multiLevelSortingState] = useState(() =>
    runInAction(
      () =>
        (state.multiLevelSorting ??= new MultiLevelSortingState<T, F>({
          table: state,
          container: state.container,
        })),
    ),
  );

  useEffect(() => multiLevelSortingState.init(), []);

  useEffect(() => {
    panels.registerSidePanel('multiLevelSorting', MultiLevelSortingPanelEntry);
  }, []);

  return (
    <CounterBadgeButton
      dataHook="multi-level-sorting-button-counter"
      count={multiLevelSortingState.sortListSize}
    >
      <Tooltip content={t('cairo.table.advanced-sorting.button.tooltip')}>
        <IconButton
          size="small"
          priority="secondary"
          dataHook="multi-level-sorting-button"
          onClick={() => {
            const isOpen = panels.toggleSidePanel('multiLevelSorting');

            if (isOpen) {
              multiLevelSortingState.reportSidePanelOpen();
            } else {
              multiLevelSortingState.reportSidePanelClose({
                origin: 'Sort CTA',
              });
            }
          }}
        >
          <ChangeOrderSmall />
        </IconButton>
      </Tooltip>
    </CounterBadgeButton>
  );
}

export const MultiLevelSortingCTAButton = observer(_MultiLevelSortingCTAButton);
